var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 137,
    viewBox: "0 0 134 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7828:52592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1875 131.25H128.812M33.4012 22.8026H37.0117M55.0648 22.8026H58.6753M33.4012 37.2443H37.0117M55.0648 37.2443H58.6753M33.4012 51.6863H37.0117M55.0648 51.6863H58.6753M33.4012 66.128H37.0117M55.0648 66.128H58.6753M33.4012 80.5701H37.0117M55.0648 80.5701H58.6753M33.4012 95.0117H37.0117M55.0648 95.0117H58.6753M95.0481 55.2983H98.6586M95.0481 69.7407H98.6586M95.0481 84.1831H98.6586M95.0481 98.6199H98.6586M76.7276 131.25V22C76.7276 12.4731 69.0045 4.75 59.4776 4.75H32.5997C23.0728 4.75 15.3497 12.4731 15.3497 22V131.25H76.7276ZM76.727 37.2443H100.663C110.19 37.2443 117.913 44.9674 117.913 54.4943V131.116H76.727V37.2443ZM51.4538 131.116V118.48C51.4538 115.489 49.0291 113.064 46.0381 113.064C43.0471 113.064 40.6224 115.489 40.6224 118.48V131.116H51.4538ZM102.269 131.115V118.478C102.269 115.487 99.8442 113.062 96.8532 113.062C93.8622 113.062 91.4375 115.487 91.4375 118.478V131.115H102.269Z",
    stroke: "#55595F",
    strokeOpacity: 0.15,
    strokeWidth: 9.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7828:52592",
    x: 0.587524,
    y: 0.149902,
    width: 132.825,
    height: 137.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7828:52592"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7828:52592",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeBuilding);
export default __webpack_public_path__ + "static/media/LargeBuilding.7f00520d27f1022cb2d563d9db7b8f75.svg";
export { ForwardRef as ReactComponent };